import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

MultiAuthSetting.propTypes = {
    usingMultiAuth: PropTypes.any,
    onChangeUsingMultiAuth: PropTypes.any
};

export default function MultiAuthSetting({ usingMultiAuth, onChangeUsingMultiAuth }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    return (
        <div className="org-profile-wrap-footer">
            <div style={{ display: 'flex', gap: 16 }}>
                <div className="org-profile-wrap-title" style={{ marginBottom: 0 }}>
                    {trI18n('LABEL-FUNCTION-MULTI-AUTH')}
                </div>
                <div className="switch-check setting-ai-function">
                    <input
                        name="multiAuth"
                        id="setting-multiAuth-switch-id"
                        type="checkbox"
                        checked={usingMultiAuth}
                        onChange={onChangeUsingMultiAuth}
                    />
                    <label htmlFor="setting-multiAuth-switch-id" style={{ color: 'transparent' }}>
                        .
                    </label>
                </div>
            </div>
            {usingMultiAuth && (
                <div className="org-profile-field" style={{ paddingBottom: 0, paddingTop: 16 }}>
                    <div className="title-name">{trI18n('AUTH-METHOD')}</div>
                    <TextField
                        className="form-control form-control--wrap form-control--hg40"
                        select
                        disabled
                        variant="outlined"
                        value={trI18n('APPLICATION-AUTH')}
                        defaultValue={trI18n('APPLICATION-AUTH')}
                    >
                        {[trI18n('APPLICATION-AUTH')].map(item => {
                            return (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                </div>
            )}
        </div>
    );
}
